var map = {
	"./10-12-2020-v2/1024/img/Wing_feathers_MetalRoughness.jpg": "5498",
	"./10-12-2020-v2/2048/img/Wing_feathers_MetalRoughness.jpg": "730f",
	"./10-12-2020-v2/512/img/Wing_feathers_MetalRoughness.jpg": "90d4",
	"./10-12-2020-v3/1024/img/Wing_feathers_MetalRoughness.jpg": "de09",
	"./10-12-2020-v3/2048/img/Wing_feathers_MetalRoughness.jpg": "963a",
	"./10-12-2020-v3/512/img/Wing_feathers_MetalRoughness.jpg": "6b50"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4829";